import { styled } from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
  width: 100%;
`
